import {FILTRAR_RESUMO_FINANCEIRO} from '../types';


export default function filtrarResumoFinanceiro(resumo, texto) {
  return {
    type: FILTRAR_RESUMO_FINANCEIRO,
    payload: { resumo, texto }
  };
}
